import { ChangeDetectorRef, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup } from '@angular/forms';
import { SolicitudService } from '../../services/solicitud.service';
import { finalize, Subject, takeUntil } from 'rxjs';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { PerfilStore } from '../../store/perfil.store';
import { Usuario, Beneficiario, ArchivosPar } from '../../models';
import { HomeService } from '../../services/home.service';
import { ImportsModule } from "../../imports.module";
import { NzSpinModule } from 'ng-zorro-antd/spin';
@Component({
  selector: 'app-envio-solicitudes',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, ImportsModule, NzSpinModule],
  templateUrl: './envio-solicitudes.component.html',
  styleUrl: './envio-solicitudes.component.scss'
})
export class EnvioSolicitudesComponent {
  
  gestanteForm!: FormGroup;
  esGestante: boolean = false;
  paresDatos: ArchivosPar[] = [];
  isUploading: boolean = false;
  errores: string[] = [];
  mensajeExito: string = '';
  loading: boolean = false;
  user ?: Usuario | null = null;
  $onDestroy: Subject<void> = new Subject<void>();
  gestantes : boolean = false;
  beneficiarios: Beneficiario[] = [];
  beneficiarioForm !: FormGroup;
  uploadProgress = {
    loaded: 0,
    total: 0,
    percentage: 0
  };
  longitud : number = 30;

  constructor(private solicitudService: SolicitudService, private cdr: ChangeDetectorRef, private message : NzMessageService, private drawerRef: NzDrawerRef, private sessionStore : PerfilStore, private homeService : HomeService, private fb : FormBuilder) {
    this.agregarPar();
  }

    ngOnInit() {
      this.getUser();
      this.ObtenerDetalleBeneficiarios();
    }
  
   getUser() {
      this.sessionStore.getPerfil()
      .pipe(takeUntil(this.$onDestroy))
      .subscribe((user:Usuario | null) => {
        this.user = user;
      });
    }

    ngOnDestroy() {
    this.$onDestroy.next();
    this.$onDestroy.complete();
  }


  agregarPar(): void {
    if (this.paresDatos.length >= 10) return;
    
    const nuevoPar: ArchivosPar = {
      id: this.generateId(),
      pdf: null,
      xml: null,
      completo: false
    };
    
    this.paresDatos.push(nuevoPar);
  }

  eliminarPar(index: number): void {
    this.paresDatos.splice(index, 1);
    this.validarFormulario();
  }

  onPdfSeleccionado(event: any, index: number): void {
    const file = event.target.files[0];
    if (file) {
      this.paresDatos[index].pdf = file;
      this.actualizarEstadoPar(index);
      this.validarFormulario();
    }
  }

  onXmlSeleccionado(event: any, index: number): void {
    const file = event.target.files[0];
    if (file) {
      this.paresDatos[index].xml = file;
      this.actualizarEstadoPar(index);
      this.validarFormulario();
    }
  }

  private actualizarEstadoPar(index: number): void {
    const par = this.paresDatos[index];
    par.completo = !!(par.pdf && par.xml);
  }

  private generateId(): string {
    return Math.random().toString(36).substr(2, 9);
  }

  validarFormulario(): void {
    this.errores = [];
    
    if (this.paresDatos.length === 0) {
      this.errores.push('Debe agregar al menos un par de archivos');
      return;
    }

    const paresCompletos = this.paresDatos.filter(par => par.completo);
    if (paresCompletos.length === 0) {
      this.errores.push('Debe completar al menos un par de archivos (PDF + XML)');
    }

    this.paresDatos.forEach((par, index) => {
      if (par.pdf) {
        if (par.pdf.type !== 'application/pdf') {
          this.errores.push(`Par ${index + 1}: El archivo PDF no es válido`);
        }
        if (par.pdf.size > 10 * 1024 * 1024) {
          this.errores.push(`Par ${index + 1}: El PDF excede 10MB`);
        }
      }

      if (par.xml) {
        if (!par.xml.type.includes('xml') && !par.xml.name.toLowerCase().endsWith('.xml')) {
          this.errores.push(`Par ${index + 1}: El archivo XML no es válido`);
        }
        if (par.xml.size > 1 * 1024 * 1024) {
          this.errores.push(`Par ${index + 1}: El XML excede 1MB`);
        }
      }

      if ((par.pdf && !par.xml) || (!par.pdf && par.xml)) {
        this.errores.push(`Par ${index + 1}: Debe incluir tanto PDF como XML`);
      }
    });
  }

  get paresCompletos(): number {
    return this.paresDatos.filter(par => par.completo).length;
  }

  get isFormValido(): boolean {
    this.validarFormulario();
    return this.errores.length === 0 && 
           this.paresDatos.length > 0 && 
           this.paresCompletos === this.paresDatos.length;
  }

  enviarSolicitud(): void {    
    try {
      if (!this.isFormValido) {
        return;
      }

      this.isUploading = true;
      this.mensajeExito = '';
      const solicitudData = {
        colaboradorId: 1, 
        esGestante: this.esGestante,
        archivosPdf: this.paresDatos.filter(par => par.pdf).map(par => par.pdf!),
        archivosXml: this.paresDatos.filter(par => par.xml).map(par => par.xml!),
        metadatos: []
      };

      const paresParaServicio = this.paresDatos.map(par => ({
        id: par.id,
        archivoPdf: par.pdf,
        archivoXml: par.xml,
        completado: par.completo
      }));
    this.solicitudService.crearSolicitudPares(solicitudData, paresParaServicio, this.esGestante, this.user?.colaboradorId!)
      .pipe(
        finalize(() => {
          this.isUploading = false;
          this.cdr.detectChanges();
        })
      )
      .subscribe({
        next: (response) => {
          this.message.success('Solicitud enviada correctamente');
          this.drawerRef.close(true)
        },
        error: (error) => {
          console.error('Error al enviar solicitud:', error);
          this.message.error('Error al enviar la solicitud. Intenta nuevamente más tarde.');
        }
      }
      )
        } catch (error) {
      console.error('Error al enviar solicitud:', error);
    }
  }

  limpiarFormulario(): void {
    this.esGestante = false;
    this.paresDatos = [];
    this.errores = [];
    this.mensajeExito = '';
    this.uploadProgress = { loaded: 0, total: 0, percentage: 0 };
    this.agregarPar();
  }

  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }


  ObtenerDetalleBeneficiarios() {
    let userId = this.user?.colaboradorId!;
    this.loading = true;
    this.homeService.obtenerDetalleBeneficiarios(userId)
    .pipe(
      finalize(() => {
        this.loading = false;
        this.cdr.detectChanges();
      })
    )
    .subscribe(
      {
        next: (res) => {
          let data = res?.details;
          this.gestantes = (data as Beneficiario[]).some(b => b.esGestante);
        },
        error: (error) => {
          console.error('Error al obtener el detalle del colaborador:', error);
        }
      }
    );
  }
}
